module.exports = {"component":"global-header","status":"prod","display-name":"Global Header","SLDS-component-path":"/components/global-header#flavor-base","dependencies":[{"component":"favorites"},{"component":"help"},{"component":"notifications"},{"component":"profile"},{"component":"search"},{"component":"setup"},{"component":"task"}],"url-slug":"global-headers"}


//////////////////
// WEBPACK FOOTER
// ./components/global-header/docs.json
// module id = 263
// module chunks = 0